import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import { Col, Row, Button, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//API
import tipoDeFiscalizacao_api from '../../../../api/tipoDeFIscalizacao_api';
import relatorio_api from '../../../../api/relatorio_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos, validarData, isDateOverflow } from '../../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../../helpers/onChangeMultiSelect';
import mascaras from '../../../../helpers/mascaras';

//Components
import TextField from '../../../../components/TextField';
import RelatorioGerenciamentoArrecadacao from './RelatorioGerenciamentoArrecadacao';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


function initialStateFiltroGerenciamentoDeArrecadacao() {
  const dataInicial = new Date();
  dataInicial.setMonth(dataInicial.getMonth() - 1);
  return {
    tipoBusca: 'Data de Infração',
    dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
    dataFinal: moment(new Date()).format("YYYY-MM-DD"),
    tipoFiscalizacao_Ids: [],
    tipoFiscalizacao_Descricao: "",
    numeroInfracao: "",
    logradouro: '',
    numero: '',
    bairro: '',
    nome: '',
    statusBoleto: 'Todos'
  }
}
export default function GerenciamentoArrecadacao() {
  //State para consultar Gereciamento de Arrecadação
  const [filtroGerenciamentoDeArrecadacao, setFiltroGerenciamentoDeArrecadacao] = useState(initialStateFiltroGerenciamentoDeArrecadacao());

  //State para pegar lista dos tipos de fiscalizacao
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para cards
  const [listaArrecadacao, setListaArrecadacao] = useState([]);

  //Estado de controle dos campos de erro
  const [errors, setErrors] = useState({});

  const { setLoading } = useAuth();

  const navigate = useNavigate();

  const datatipoBusca = [
    { value: "Data de Infração", label: "Data de Infração" },
    { value: "Data do Boleto", label: "Data do Boleto" },
    { value: "Vencimento do Boleto", label: "Vencimento do Boleto" },
    { value: "Data de Pagamento", label: "Data de Pagamento" },
  ];

  const dataStatusBoleto = [
    { value: "Todos", label: "Todos" },
    { value: "Registrado", label: "Registrado" },
    { value: "Cancelado", label: "Cancelado" },
    { value: "Vencido", label: "Vencido" },
    { value: "Liquidado", label: "Liquidado" },
  ];

  //Estado de controle dos campos obrigatorios 
  const [campos] = useState([
    objCampo({ name: "tipoBusca", required: true }),
    objCampo({ name: "statusBoleto", required: true })
  ]);

  const loadTipoDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFiscalizacao_api.getList()
      .then(response => {
        response.data.map(value => {
          value.value = value.id;
          value.label = value.identificacao;
          return value;
        })
        //Sem a opção "Todos": nenhum tipo selecionado já significa todos os tipos
        setListTipoDeFiscalizacao(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFiltroGerenciamentoDeArrecadacao({
      ...filtroGerenciamentoDeArrecadacao,
      [name]: value
    })
  }

  const onChangeMultiSelectGerenciamentoDeArrecadacao = criarOnChangeMultiSelect({
    state: filtroGerenciamentoDeArrecadacao,
    setState: setFiltroGerenciamentoDeArrecadacao
  });

  const onChangeGerenciamentoDeArrecadacao = (value, e) => {
    const _filtroGerenciamentoDeArrecadacao = {
      ...filtroGerenciamentoDeArrecadacao,
      [e.name]: value ? value.value.toString() : null,
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === e.name);
    const fieldError = validarCampos(_filtroGerenciamentoDeArrecadacao, _campos);

    const _errors = { ...errors };
    delete _errors[e.name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setFiltroGerenciamentoDeArrecadacao(_filtroGerenciamentoDeArrecadacao);
  }

  const handleFiltroArrecadacao = () => {
    //Realizando a validação dos campos obrigatorios
    const _errors = validarCampos(filtroGerenciamentoDeArrecadacao, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    //Data Inicial/Final são opcionais quando Nome do Infrator ou Número da Infração forem informados
    const possuiFiltroAlternativo = !!(filtroGerenciamentoDeArrecadacao.nome?.trim() || filtroGerenciamentoDeArrecadacao.numeroInfracao?.trim());

    if (!possuiFiltroAlternativo && (!filtroGerenciamentoDeArrecadacao.dataInicial || !filtroGerenciamentoDeArrecadacao.dataFinal)) {
      return showMessage("Aviso", "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator ou Número da Infração.", "warning", null);
    }

    if (filtroGerenciamentoDeArrecadacao.dataInicial && !validarData(filtroGerenciamentoDeArrecadacao.dataInicial)) {
      return showMessage(
        "Aviso",
        `A data início informada não é válida. Verifique o valor informado no calendário.`,
        "warning",
        null
      );
    }
    if (filtroGerenciamentoDeArrecadacao.dataFinal && !validarData(filtroGerenciamentoDeArrecadacao.dataFinal)) {
      return showMessage(
        "Aviso",
        `A data final informada não é válida. Verifique o valor informado no calendário.`,
        "warning",
        null
      );
    }

    if (filtroGerenciamentoDeArrecadacao.dataInicial && filtroGerenciamentoDeArrecadacao.dataFinal &&
      isDateOverflow(filtroGerenciamentoDeArrecadacao.dataInicial, filtroGerenciamentoDeArrecadacao.dataFinal, 12, 'months')) {
      return showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null);
    }

    setFiltroGerenciamentoDeArrecadacao({
      ...filtroGerenciamentoDeArrecadacao,
      tipoFiscalizacao_Descricao: (filtroGerenciamentoDeArrecadacao.tipoFiscalizacao_Ids ?? []).length === 0
        ? "Todos"
        : listTipoDeFiscalizacao
          .filter(value => filtroGerenciamentoDeArrecadacao.tipoFiscalizacao_Ids.includes(value.value))
          .map(value => value.label)
          .join(", ")
    })

    setLoading(true);
    relatorio_api.RelatorioGerenciamentoArrecadacao(filtroGerenciamentoDeArrecadacao)
      .then(response => {
        response.data = response.data?.map(value => {
          value.documentoInfrator = mascaras.cpfcnpjMask(value.documentoInfrator);
          return value
        })
        setListaArrecadacao(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  const handleVoltar = () => {
    setListaArrecadacao([]);
  }

  useEffect(() => {
    loadTipoDeFiscalizacao();
  }, []);

  if (listaArrecadacao.length > 0) {
    return <RelatorioGerenciamentoArrecadacao
      handleVoltar={handleVoltar}
      listaArrecadacao={listaArrecadacao}
      filtros={filtroGerenciamentoDeArrecadacao}
    />
  }

  return <Card className='shadowFicha mainContainerFicha p-4'>
    <div className='mb-3'>
      <Button color='secondary' className='text-white' onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faArrowLeft} />
        <span className='px-2'> Voltar </span>
      </Button>
    </div>
    <h4 className='text-secondary m-0'>Gerenciamento de Arrecadação</h4>
    <Row className='mt-3'>
      <Col md={12} lg={3}>
        <TextField
          type={"select"}
          name={"tipoBusca"}
          label={"* Tipo de Busca"}
          searchable
          options={datatipoBusca}
          onChange={onChangeGerenciamentoDeArrecadacao}
          value={
            datatipoBusca.filter(value => value.value == filtroGerenciamentoDeArrecadacao.tipoBusca)
              .map(v => { return { value: v.value, label: v.value } })
          }
          invalid={!!errors.tipoBusca}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"select"}
          name={"statusBoleto"}
          label={"* Status Boleto"}
          searchable
          options={dataStatusBoleto}
          onChange={onChangeGerenciamentoDeArrecadacao}
          value={
            dataStatusBoleto.filter(value => value.value == filtroGerenciamentoDeArrecadacao.statusBoleto)
              .map(v => { return { value: v.value, label: v.value } })
          }
          invalid={!!errors.statusBoleto}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"date"}
          name={"dataInicial"}
          label={"Data Inicial"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.dataInicial}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"date"}
          name={"dataFinal"}
          label={"Data Final"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.dataFinal}
        />
      </Col>
      <Col md={12} lg={6}>
        <TextField
          type={"select"}
          name={"tipoFiscalizacao_Ids"}
          label={"Tipo de Fiscalização"}
          placeholder={"Todos"}
          multiple
          options={listTipoDeFiscalizacao}
          onChange={onChangeMultiSelectGerenciamentoDeArrecadacao}
          value={listTipoDeFiscalizacao.filter(value => (filtroGerenciamentoDeArrecadacao.tipoFiscalizacao_Ids ?? []).includes(value.value))}
        />
      </Col>
      <Col md={12} lg={6}>
        <TextField
          type={"text"}
          name={"numeroInfracao"}
          label={"Número da infração"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.numeroInfracao}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"text"}
          name={"nome"}
          label={"Nome"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.nome}
        />
      </Col>


      <Col md={12} lg={3}>
        <TextField
          type={"text"}
          name={"bairro"}
          label={"Bairro"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.bairro}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"text"}
          name={"logradouro"}
          label={"Logradouro"}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.logradouro}
        />
      </Col>
      <Col md={12} lg={2}>
        <TextField
          type={"text"}
          name={"numero"}
          label={"Numero"}
          mask={mascaras.numeroMask}
          onChange={onChange}
          value={filtroGerenciamentoDeArrecadacao.numero}
        />
      </Col>

      <Col md={12} lg={2}>
        <Button
          className='w-100 fw-bold'
          color='info text-light'
          onClick={handleFiltroArrecadacao}>Gerar Relatório</Button>
      </Col>
    </Row>
  </Card>;
}
